const mEditionProductAutorespondersListsModalCreate = {
  mEditionProductAutorespondersListsModalCreate: {
    alerts: {
      createProductoAutoresponderLista: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La lista de autoresponder fue asociada exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ASOCIAR',

    errorMessages: {
      emptyLists: 'Aún no tienes listas creadas en tu cuenta de autoresponder por lo que no podrás realizar esta acción.',
      invalidAutoresponder: 'Un error ha ocurrido, verifica si tu cuenta de autoresponder es válida.'
    },

    inputs: {
      academia_autoresponder: {
        label: 'Cuenta de Autoresponder'
      },

      lista: {
        label: 'Lista de Autoresponder'
      }
    },

    title: 'ASOCIAR LISTA',

    validation: {
      academia_autoresponder: {
        required: 'Cuenta de autoresponder es requerida.'
      },

      lista: {
        required: 'Lista de autoresponder es requerida'
      }
    }
  }
}

export default mEditionProductAutorespondersListsModalCreate
